import React, { useEffect, useState } from "react";

// UI Components
import { toastr } from "react-redux-toastr";
import { Button, Spinner } from "reactstrap";
import MicrosoftLogin from "react-microsoft-login";

// Custom Utils
import { log } from "../../utils/logger";
import { client_config } from "../../utils/clientConfigs";

const AzureSSO = ({ ssoUser }) => {
  const [authData, setAuthData] = useState({});
  const [msalInstance, onMsalInstanceChange] = useState();

  const { REACT_APP_AZURE_CLIENT_ID } = process.env;
  if (!REACT_APP_AZURE_CLIENT_ID) {
    throw new Error("Missing Azure Client ID");
  }

  useEffect(() => {
    if (authData.accessToken) {
      log("Signing user in", authData);
      ssoUser({ type: "azure", authData });
      setTimeout(() => {
        sessionStorage.clear();
        setAuthData({});
      }, 50);
    }
  }, [authData, ssoUser, msalInstance]);

  if (!client_config.enabled_features.sso_microsoft) {
    // Not configured for this user
    return null;
  }

  const loginHandler = (err, authData, msal) => {
    if (err) {
      return toastr.error(
        "Sorry",
        "There was an unexpected issue logging in with your provider. Please notify customer support"
      );
    }

    // Store the results
    setAuthData(authData);
    onMsalInstanceChange(msal);
  };

  return (
    <div>
      <hr />

      <div className="m-sm-4 text-center">
        {authData.accessToken ? (
          <Button color="secondary" outline disabled>
            <Spinner size="sm" className="mr-2" />
            Please wait
          </Button>
        ) : (
          <MicrosoftLogin
            debug={true}
            authCallback={loginHandler}
            graphScopes={["User.Read", "Directory.AccessAsUser.All"]}
            // withUserData={true}
            clientId={REACT_APP_AZURE_CLIENT_ID}
          />
        )}
      </div>
    </div>
  );
};

export default AzureSSO;
